import React from 'react';
import RadioButton from 'components/DesignSystem/RadioButton';

interface RadioSelectorItem<T> {
  value: T;
  label: string;
}

export default function RadioSelector<T extends string | number>({
  filteredItems,
  value,
  setValue,
}: {
  filteredItems: RadioSelectorItem<T>[],
  value: T;
  setValue: React.Dispatch<React.SetStateAction<T>>;
}) {
  return (
    <>
      {filteredItems.map((item) => (
        <RadioButton
          key={item.value?.toString()}
          label={item.label}
          value={item.value}
          onChange={() => setValue(item.value)}
          checked={value === item.value}
        />
      ))}
    </>
  );
}
